const storageService = function (storage) {
  const _storage = window[storage]

  if (!_storage) {
    throw new Error(`storage type: ${storage} is not supported !`)
  }

  function getVal (key) {
    let _data = _storage.getItem(key)
    if (!_data || _data === 'undefined') {
      return null
    }
    return JSON.parse(_data)
  }

  function getAllVal () {
    const _len = _storage.length
    if (_len < 1) {
      return null
    }
    let result = {}
    for (let i = 0; i < _len; i++) {
      let _key = _storage.key(i)
      result[_key] = getVal(_key)
    }
    return result
  }

  return {
    set (key, value) {
      _storage.setItem(key, JSON.stringify(value))
    },
    get (key) {
      return typeof key === 'undefined' ? getAllVal() : getVal(key)
    },
    remove (key) {
      _storage.removeItem(key)
    },
    clear () {
      _storage.clear()
    }
  }
}

const SessionStorage = storageService('sessionStorage')
const LocalStorage = storageService('localStorage')

export {
  SessionStorage,
  LocalStorage
}

export default SessionStorage



// WEBPACK FOOTER //
// ./src/utils/storage.js